var ArbitrarySubjects = {
	ANSWER: "JournalActivityAnswer",
	QUIZ_ANSWER: "QuizAnswer",
	EXERCISE: "JournalActivityExercise",
	REVIEW: "JournalActivityReview",
	DRAFT: "Draft",
	CLASS_BOOK: "ClassBook",
	MONTH_LOGS: "MonthLogTable",
	QUESTION_BUILDER: "JournalActivityQuestionBuilder",
	ESSAY: "Essay",

	onReadingPage(type) {
		var config = ArbitrarySubjects.CONFIG[type];
		return config && config.isReading;
	},

	asCollection(type) {
		var config = ArbitrarySubjects.CONFIG[type];
		if (config) {
			return config.collectionName;
		}
	},

	fromCollection(collectionName) {
		return _.find(_.values(ArbitrarySubjects.TYPES), function(subjectType) {
			return collectionName == ArbitrarySubjects.asCollection(subjectType);
		});
	}
}

ArbitrarySubjects.TYPES = [ArbitrarySubjects.ANSWER, ArbitrarySubjects.QUIZ_ANSWER, 
	ArbitrarySubjects.EXERCISE, ArbitrarySubjects.REVIEW, ArbitrarySubjects.CLASS_BOOK,
	ArbitrarySubjects.DRAFT, ArbitrarySubjects.QUESTION_BUILDER]

ArbitrarySubjects.CONFIG = {}
ArbitrarySubjects.CONFIG[ArbitrarySubjects.ANSWER] = {
	collectionName: "answers"
}
ArbitrarySubjects.CONFIG[ArbitrarySubjects.QUIZ_ANSWER] = {
	collectionName: "quizzes"
}
ArbitrarySubjects.CONFIG[ArbitrarySubjects.EXERCISE] = {
	collectionName: "exercises"
}
ArbitrarySubjects.CONFIG[ArbitrarySubjects.REVIEW] = {
	collectionName: "reviews"
}
ArbitrarySubjects.CONFIG[ArbitrarySubjects.CLASS_BOOK] = {
	collectionName: "class_activity"
}
ArbitrarySubjects.CONFIG[ArbitrarySubjects.DRAFT] = {
	collectionName: "drafts"
}
ArbitrarySubjects.CONFIG[ArbitrarySubjects.TEACHERS_PICK] = {
	collectionName: "teachers_pick"
}
ArbitrarySubjects.CONFIG[ArbitrarySubjects.MONTH_LOGS] = {
	isReading: true,
	collectionName: "logs"
}
ArbitrarySubjects.CONFIG[ArbitrarySubjects.QUESTION_BUILDER] = {
	collectionName: "question_builders"
}
ArbitrarySubjects.CONFIG[ArbitrarySubjects.ESSAY] = {
	collectionName: "essays"
}
module.exports = ArbitrarySubjects;


// WEBPACK FOOTER //
// ./modules/lib/data/ArbitrarySubjects.js